import axiosInstance from "./http/axios_instance"
const http_protected = axiosInstance("/protected", "/logout")

const getRole = () => http_protected.get("/role")

export default {
    getRole
}
